<div class="qa-codes">
	<app-rc-qa-codes [rules]="rules"></app-rc-qa-codes>
	<div>{{hoveredAddr?.id}}</div>
</div>
<div class="align-wrap">
	<div class="column-list">
		<div class="cell-item" *ngFor="let col of cols" appHtmlTooltip [tooltip]="col.htmlTooltip">{{col.label}}</div>
	</div>
	<div class="middle-content">
		<div *ngFor="let col of cols" class="address-prop">
			<div *ngFor="let addr of addrList; let idx = index" 
				class="cell-item" 
				(click)="clickAddr(addr)" 
				(mouseover)="hoveredAddr=addr">
				<app-rc-cell [column]="col" [rcRecordItem]="addr" [domain]="addr.domainsByColumn[col.prop]" (edit)="onEditCell(idx, $event)"></app-rc-cell>
				<!-- <input *ngIf="!col.domains" name="{{col.prop}}-{{idx}}" [(ngModel)]="addr.props[col.prop]" (ngModelChange)="onEdit(idx, col)">
				<select *ngIf="col.domains" name="{{col.prop}}-{{idx}}" [(ngModel)]="addr.props[col.prop]" (ngModelChange)="onEdit(idx, col)">
					<option *ngFor="let val of col.domains">{{val}}</option>
					<option [ngValue]="null">Null</option>
				</select> -->
			</div>
		</div>
	</div>
	<!-- <div class="align-row" *ngFor="let col of cols; let colIdx = index">
		<div class="cell-item">{{col.label}}</div>
		<div *ngFor="let addr of addrList; let idx = index" class="cell-item">
			<input name="{{col.prop}}-{{idx}}" [(ngModel)]="addr.props[col.prop]">
		</div>
	</div> -->

</div>